// extracted by css-extract-rspack-plugin
export default {"container":"_1c49cf38","heading":"_7ab90b97"};